const divConfirmTenant = {
  access: 'Acesso adicionado com sucesso',
  link: 'Link expirado'
};

export default divConfirmTenant;
